<template>
  <div>
    <div class="md:flex md:items-center mb-6">
      <label>Project Name</label>
      <div class="md:w-2/3">
        <input v-model="name" class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500" id="inline-name" type="text" value="Project name" name="Project Name">
      </div>
    </div>
    <div class="md:flex md:items-center mb-6">
      <label> Branch name</label>
      <div class="md:w-2/3">
        <input v-model="branch" class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500" id="inline-name" type="text" value="Branch name" name="Branch Name">
      </div>
    </div>
    <div class="md:flex md:items-center mb-6">
      <label>Serve command</label>
      <div class="md:w-2/3">
        <input v-model="serveCommand" class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500" id="inline-name" type="text" value="Serve command" name="Serve command">
      </div>
    </div>
    <div class="md:flex md:items-center mb-6">
      <label>Environment variables</label>
      <textarea v-model="envVar" class="md:w-2/3 bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500" id="inline-name" type="textarea" value="Env variable" name="Env variable">
      </textarea>
    </div>
    <div class="md:flex md:items-center mb-6">
      <input v-model="password" class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500" id="password" type="password" placeholder="Password">
    </div>
    <div class="md:flex md:items-center">
      <div class="md:w-1/3"></div>
      <div class="md:w-2/3">
          <button @click.prevent="addProject" class="bg-yellow-500 hover:bg-yellw-700 text-white font-bold py-2 px-4 border border-yellow-700 rounded">
          Add project
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectSettings'
}
</script>

<style>

</style>
